// src/components/GolfIcon.tsx
interface GolfIconProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  filled?: boolean;
  themeAware?: boolean;
}

const GolfIcon = ({ name, className = '', style, filled = false, themeAware = true }: GolfIconProps) => {
  // Use filled version if available and requested
  const iconName = filled ? `${name}-filled` : name;

  return (
    <img
      src={`/assets/images/icons/${iconName}.svg`}
      className={`${className} ${themeAware ? 'dark:invert' : ''}`}
      alt={name}
      style={style}
      draggable={false}
    />
  );
};

export default GolfIcon;